var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailoredSolutionsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.04,
    height: 38.4,
    rx: 8,
    fill: "#EBF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9105 15.4219H23.2983V8.8098C23.2983 8.28813 22.8755 7.86523 22.3538 7.86523H16.6863H9.12957C8.60789 7.86523 8.185 8.28813 8.185 8.8098V16.3665V22.034C8.185 22.5557 8.60789 22.9786 9.12957 22.9786H15.7417V29.5907C15.7417 30.1123 16.1645 30.5352 16.6862 30.5352H29.9104C30.4321 30.5352 30.855 30.1123 30.855 29.5907V16.3665C30.855 15.8448 30.4321 15.4219 29.9105 15.4219ZM10.0742 9.75442H15.7417V15.4219H10.0742V9.75442ZM10.0742 17.3111H16.6863C17.2079 17.3111 17.6308 16.8882 17.6308 16.3665V9.75442H21.4092V16.3665V21.0894H16.6863H10.0742V17.3111ZM28.9659 28.6461H17.6308V22.9786H22.3538C22.8755 22.9786 23.2983 22.5557 23.2983 22.034V17.3111H28.9659V28.6461Z",
    fill: "#0069CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.67,
    height: 22.67,
    fill: "white",
    transform: "translate(8.185 7.86523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredSolutionsImage);
export default __webpack_public_path__ + "static/media/Tailored-solutions-image.a7c2305fce6f4cd9a53520897f852915.svg";
export { ForwardRef as ReactComponent };